module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-container"
  }, [_c('div', {
    staticClass: "slides"
  }, [(!_vm.options.loop) ? [_vm._l((_vm.pages), function(item, i) {
    return [_c('a', {
      staticClass: "slide",
      style: (item.style),
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.title))])]
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-62e1482a"}!./~/._vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/index.vue
// module id = 161
// module chunks = 1